export default {
  getListStatus (state) {
    return state.status ? state.status : []
  },
  getStatusUser (state) {
    return state.status.USER ? state.status.USER.NAME : []
  },
  getStatusUserCode (state) {
    return state.status.USER ? state.status.USER.CODE : []
  },
  getStatusCheckerMaker (state) {
    return state.status.CHECKER_MAKER ? state.status.CHECKER_MAKER.NAME : []
  },
  getStatusChecklist (state) {
    return state.status.CHECKLIST ? state.status.CHECKLIST.NAME : []
  }
}



// WEBPACK FOOTER //
// ./src/store/module/status/getters.js